import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomepageComponent from './Components/HomepageComponent';
import LoginPage from './Components/Authentications/SigninComponent';
import SignUp from './Components/Authentications/SignupComponent';
import Dashboard from './Components/Dashboard/DashboardComponent';
import ForgotPasswordPage from './Components/Authentications/ForgotPassword';
import VerifyOtpPage from './Components/Authentications/VerifyOtpComponent';
import StaffRegistration from './Components/Staff/StaffComponent';
import FormDetailsTable from './Components/userforms/userform';
import ReceiveFromManagement from './Components/recievedfrom/receivedfrom';
import SectionFromManagement from './Components/sectionfrom/sectionfrom';
import CreateCurrent from './Components/userforms/Createform';
const App = () => {
    return (
        <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/signup" element={<SignUp />} /> {/* Separate Sign Up Route */}
            <Route element={<HomepageComponent />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/staff" element={<StaffRegistration />} />
                <Route path ="/formdetails" element={<FormDetailsTable/>}/>
                <Route path ="/receivedfrom" element={<ReceiveFromManagement/>}/>   
                <Route path ="/sectionfrom" element={<SectionFromManagement/>}/>
                 <Route path ="/createform" element={<CreateCurrent/>}/>

            </Route>
            {/* <Route path='/resetpassword' element={<ResetPasswordPage />} />
            <Route path='/forgetpassword' element={<Forgetpassword />} />
            <Route path='/forgetpassword1' element={<Forgetpassword1 />} /> */}
            <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
            <Route path="/verify-otp" element={<VerifyOtpPage />} />


        </Routes>
    );
};

export default App;
